export const CARE_SITES = {
  nj: {
    key: "nj",
    brand: "Heritage Homecare",
    region: "New Jersey",
    productName: "Heritage Homecare NJ",
    tagline:
      "Clinical-grade home care, delivered with the warmth of family.",
    heroEyebrow: "Hoboken · New Jersey",
    heroLines: [
      "Care that comes home.",
      "Hearts that stay.",
    ],
    heroSub:
      "From post-surgery recovery to round-the-clock live-in care, our caregivers help New Jersey families keep their loved ones safe, dignified, and at home.",
    heroImage:
      "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?auto=format&fit=crop&w=1600&q=85",
    heroImageAlt:
      "Caregiver tenderly supporting an elderly woman at home",
    accent: "#C86A51",
    marquee: [
      "Licensed & Bonded",
      "24/7 Live-in Care",
      "RN Supervised",
      "Serving All of Hudson County",
      "Private Pay & Long-Term Care Insurance",
    ],
    services: [
      {
        key: "personal-care",
        title: "Personal Care",
        desc:
          "Dignified help with bathing, dressing, grooming, mobility and daily routines.",
        image:
          "https://images.pexels.com/photos/7551617/pexels-photo-7551617.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "skilled-nursing",
        title: "Skilled Nursing",
        desc:
          "RNs and LPNs for wound care, medication management, chronic disease and vitals.",
        image:
          "https://images.pexels.com/photos/7446988/pexels-photo-7446988.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "memory-care",
        title: "Dementia & Alzheimer's Care",
        desc:
          "Specialized memory-care caregivers trained in redirection, routine and safety.",
        image:
          "https://images.pexels.com/photos/7551681/pexels-photo-7551681.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "post-surgery",
        title: "Post-Surgery Recovery",
        desc:
          "Short-term care to accelerate healing after hospital discharge or procedures.",
        image:
          "https://images.pexels.com/photos/7551629/pexels-photo-7551629.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "hospice",
        title: "Hospice Support",
        desc:
          "Gentle, respectful companionship and physical support working alongside hospice teams.",
        image:
          "https://images.pexels.com/photos/5257532/pexels-photo-5257532.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "live-in",
        title: "24/7 Live-in Care",
        desc:
          "A trusted caregiver in your home around the clock — safety and companionship, always.",
        image:
          "https://images.pexels.com/photos/7551604/pexels-photo-7551604.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
    ],
    address: {
      street: "80 River Street, Suite 2D",
      locality: "Hoboken, NJ 07030",
      mapsQuery: "80 River Street Suite 2D Hoboken NJ 07030",
    },
    phone: "201.477.8151",
    phoneHref: "tel:+12014778151",
    clientRates: {
      note: "Transparent, private-pay rates aligned with the Hudson County market. Rates include caregiver pay, taxes, insurance, and 24/7 care coordination. Long-term care insurance accepted.",
      items: [
        { label: "Companion Care", unit: "hour", from: 28, min: "20-hour weekly minimum" },
        { label: "Certified Home Health Aide", unit: "hour", from: 32, min: "20-hour weekly minimum" },
        { label: "Skilled Nursing (LPN)", unit: "hour", from: 65, min: "Call for custom plan" },
        { label: "Overnight Care (10 hrs)", unit: "night", from: 320, min: "Awake caregiver" },
        { label: "24/7 Live-in Care", unit: "day", from: 380, min: "Weekly minimum" },
      ],
      disclaimer:
        "Rates shown are starting points — actual pricing depends on acuity, hours, and schedule. We’ll provide a flat, written quote after a free in-home assessment.",
    },
    hiringRates: {
      note: "We pay above the Hudson County market, provide paid training, and offer weekly direct deposit. W-2 employment, workers’ comp and liability included.",
      roles: [
        { role: "Companion Caregiver", pay: "$18 – $22 / hr", notes: "Flexible shifts" },
        { role: "Certified Home Health Aide (CHHA)", pay: "$20 – $26 / hr", notes: "CHHA cert required" },
        { role: "Licensed Practical Nurse (LPN)", pay: "$38 – $48 / hr", notes: "Active NJ license" },
        { role: "Registered Nurse (RN)", pay: "$50 – $65 / hr", notes: "On-call & field roles" },
        { role: "Live-in Caregiver", pay: "$220 – $280 / day", notes: "Private room + meals" },
      ],
      perks: [
        "Weekly direct deposit",
        "Paid orientation & continuing education",
        "Referral & attendance bonuses",
        "Overtime after 40 hrs",
        "Flexible scheduling",
      ],
    },
    sisterSite: {
      label: "Visit Heritage Companion Care in New York",
      to: "/ny",
    },
  },

  ny: {
    key: "ny",
    brand: "Heritage Companion Care",
    region: "New York",
    productName: "Heritage Companion Care NY",
    tagline:
      "A private-pay companionship and senior lifestyle-support company for New Yorkers who want to stay independent at home.",
    heroEyebrow: "Midtown · New York",
    heroLines: [
      "Companionship,",
      "the New York way.",
    ],
    heroSub:
      "Heritage Companion Care NY is a private-pay companionship and senior lifestyle-support company. From a stroll in the park to a grocery run, we help your loved one stay independent, engaged, and never alone.",
    heroImage:
      "https://images.unsplash.com/photo-1658632302217-984d432b4d38?auto=format&fit=crop&w=1600&q=85",
    heroImageAlt:
      "Elderly couple relaxing warmly in a sunlit living room",
    accent: "#C86A51",
    marquee: [
      "Insured & Vetted Companions",
      "Flexible Hourly Visits",
      "Serving all 5 Boroughs",
      "Weekends & Evenings Welcome",
      "No Long-Term Contracts",
    ],
    services: [
      {
        key: "companionship",
        title: "Companionship",
        desc:
          "Meaningful conversation, shared hobbies, walks in the park and simply being present.",
        image:
          "https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "housekeeping",
        title: "Light Housekeeping",
        desc:
          "Tidying, laundry, linens and keeping the home a calm, comfortable place to live.",
        image:
          "https://images.pexels.com/photos/6692131/pexels-photo-6692131.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "meal-prep",
        title: "Meal Preparation",
        desc:
          "Nutritious, familiar meals cooked at home — including dietary accommodations.",
        image:
          "https://images.pexels.com/photos/4057744/pexels-photo-4057744.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "transport",
        title: "Transportation & Errands",
        desc:
          "Appointments, groceries, pharmacy runs — accompanied door-to-door across the city.",
        image:
          "https://images.pexels.com/photos/7551623/pexels-photo-7551623.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "medication-reminders",
        title: "Medication Reminders",
        desc:
          "Gentle, scheduled reminders to help your loved one stay on top of their medications.",
        image:
          "https://images.pexels.com/photos/3683098/pexels-photo-3683098.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
      {
        key: "respite",
        title: "Respite for Family",
        desc:
          "Short-notice relief for family caregivers — a few hours or a full day, when you need it.",
        image:
          "https://images.pexels.com/photos/7551618/pexels-photo-7551618.jpeg?auto=compress&cs=tinysrgb&w=1200",
      },
    ],
    address: {
      street: "1350 Avenue of the Americas, Floor 2",
      locality: "New York, NY 10019",
      mapsQuery: "1350 Avenue of the Americas Floor 2 New York NY 10019",
    },
    phone: null,
    phoneHref: null,
    clientRates: {
      note: "Heritage Companion Care NY is a private-pay companionship and senior lifestyle-support company. Transparent rates aligned with the Manhattan market — all rates include caregiver pay, insurance, and 24/7 care coordination.",
      items: [
        { label: "Companion Care", unit: "hour", from: 32, min: "20-hour weekly minimum" },
        { label: "Overnight Care (10 hrs)", unit: "night", from: 360, min: "Awake caregiver" },
        { label: "Live-in Companion", unit: "day", from: 420, min: "Weekly minimum" },
        { label: "Weekend / Holiday", unit: "hour", from: 36, min: "+15% premium applies" },
      ],
      disclaimer:
        "Rates shown are starting points — actual pricing depends on care needs, hours, and schedule. A written quote follows a complimentary intake.",
    },
    hiringRates: {
      note: "We hire companions providing lifestyle-support services only. Competitive pay above market, weekly direct deposit, and health benefits for full-time W-2 employees across all five boroughs.",
      roles: [
        { role: "Companion", pay: "$20 – $26 / hr", notes: "Flexible shifts citywide" },
        { role: "Live-in Companion", pay: "$250 – $320 / day", notes: "Room + meals included" },
        { role: "Overnight Caregiver", pay: "$240 – $300 / shift", notes: "10-hr awake shifts" },
        { role: "Weekend / Evening", pay: "+15% premium", notes: "Added to hourly rate" },
      ],
      perks: [
        "Weekly direct deposit",
        "Health benefits for full-time",
        "Metrocard reimbursement",
        "Paid training & certification support",
        "Overtime after 40 hrs",
      ],
    },
    scope: {
      title: "Scope of Services",
      intro:
        "Heritage Companion Care NY is a private-pay companionship and senior lifestyle-support company — not a licensed home-health agency. We do not provide hands-on personal care or medical tasks. The table below reflects New York guidance for non-medical companion services.",
      items: [
        {
          service: "Social companionship and conversation",
          approach: "Generally appropriate",
          status: "appropriate",
        },
        {
          service: "Recreational activities and social outings",
          approach: "Generally appropriate",
          status: "appropriate",
        },
        {
          service: "Friendly visits and social engagement",
          approach: "Generally appropriate",
          status: "appropriate",
        },
        {
          service: "Light housekeeping incidental to companionship",
          approach: "Expressly contemplated in NY guidance",
          status: "contemplated",
        },
        {
          service: "Grocery shopping and errands",
          approach: "Confirm the specific service arrangement",
          status: "confirm",
        },
        {
          service: "Appointment accompaniment",
          approach: "Generally possible without providing medical or personal care",
          status: "appropriate",
        },
        {
          service: "Bathing, dressing, toileting, transfers",
          approach: "Exclude until appropriately licensed",
          status: "exclude",
        },
        {
          service: "Nursing and medication administration",
          approach: "Exclude until appropriately authorized",
          status: "exclude",
        },
      ],
    },
    sisterSite: {
      label: "Visit Heritage Homecare in New Jersey",
      to: "/nj",
    },
  },
};
